import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
    height: 'calc(100vh - 48px)',
    paddingBottom: spacing(32),
  },
  actionButtons: {
    display: 'flex',
    gap: spacing(8),
  },
  button: {
    padding: spacing(8, 16),
    margin: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    minWidth: spacing(120),
    backgroundColor: 'transparent',
    fontSize: spacing(14),
    borderRadius: '75px',

    '&:not(:disabled):hover': {
      opacity: '0.8',
    },

    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'visible',
      color: palette.gray[32],
      backgroundColor: palette.gray[4],
    },
  },
  buttonBlue: {
    background: 'transparent',
    color: palette.primary.main,
    border: `1px solid ${palette.primary.main}`,

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  content: {
    display: 'flex',
    width: '100%',
    height: 'calc(100% - 75px)',
    overflowY: 'auto',
    paddingLeft: spacing(24),
    paddingRight: spacing(24),
  },
  form: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: spacing(24),
  },
  main: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: spacing(30),
  },
  label: {
    color: palette.gray[64],
    fontSize: spacing(12),
  },
  maskInput: {
    '& .MuiInputBase-root': {
      height: `33px !important`,
    },
  },
  box: {
    display: 'flex',
    gap: spacing(50),
    width: '100%',
  },
  subcontainer: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(38, 22, 22),
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: spacing(24),
  },
  groupLabel: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    alignItems: 'start',
    width: '100%',
    gap: spacing(44),
  },
  wrapperFull: {
    width: '100%',
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: 'auto',
    marginTop: spacing(4),
  },
  checkboxRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: spacing(16),
  },
  inlineCheckbox: {
    width: 'auto !important',
    minWidth: 'fit-content',
    flex: '0 0 auto',
  },
  row: {
    display: 'grid',
    gap: spacing(50),
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  rowTwoColumns: {
    display: 'grid',
    gap: spacing(50),
    gridTemplateColumns: '1fr 1fr',
  },
}))
